import { api } from "@/lib/api";

// Session cache of file blob object URLs (by file id) so thumbnails and the
// lightbox reuse a single fetch/URL — opening a preview is instant on cache hit.
const cache = new Map(); // fileId -> Promise<{ blob, url }>

export function getFileBlobUrl(fileId) {
  if (!cache.has(fileId)) {
    const p = api.get(`/files/${fileId}/download`, { responseType: "blob" })
      .then((res) => ({ blob: res.data, url: URL.createObjectURL(res.data) }));
    p.catch(() => cache.delete(fileId)); // don't cache failures
    cache.set(fileId, p);
  }
  return cache.get(fileId);
}

export function invalidateFileBlob(fileId) {
  const p = cache.get(fileId);
  if (!p) return;
  cache.delete(fileId);
  p.then(({ url }) => URL.revokeObjectURL(url)).catch(() => {});
}
